import { trimSpaces } from "@/gql/lib";
import { ref } from "@vue/composition-api";

export type PopupPosition =
  | "top"
  | "bottom"
  | "left"
  | "right"
  | "top-left"
  | "bottom-left";

export type PopupType =
  | "simple-display-items"
  | "icon-and-text-display-items"
  | "custom";

export interface BasePopupConfig {
  position: PopupPosition;
  event: MouseEvent;
  width: number;
  height?: number;
  preventOnScrollClose?: boolean;
}

export interface TextDisplayPopup extends BasePopupConfig {
  type: "TextDisplayPopup";
  items: string[];
}

export interface TextAndIconDisplayPopup extends BasePopupConfig {
  type: "TextAndIconDisplayPopup";
  items: Array<{ text: string; icon: string }>;
}

export interface CustomDisplayPopup extends BasePopupConfig {
  type: "CustomDisplayPopup";
  items: any[];
  // vue component
  cmp: unknown;
}

export interface PopupActionResult {
  type: "success";
  action: any;
}

export interface PopupCanceledResult {
  type: "canceled";
}

export type PopupResult = PopupActionResult | PopupCanceledResult;

export type PopupConfig =
  | TextDisplayPopup
  | TextAndIconDisplayPopup
  | CustomDisplayPopup;

export type PopupDisplayListener = (config: PopupConfig, cb: Function) => void;
export type PopupDisplayActionsListener = (
  config: PopupConfig
) => Promise<PopupResult>;

export const UsePopup = (() => {
  let popupDisplayListener: PopupDisplayListener;
  let popupDisplayActionsListener: PopupDisplayActionsListener;
  const _isOpen = ref(false);
  let hasRootListener = false;

  const isOpen = () => _isOpen.value;

  const showDisplayPopup = (config: PopupConfig) => {
    _isOpen.value = true;
    popupDisplayListener &&
      popupDisplayListener(config, () => {
        _isOpen.value = false;
      });
  };

  const showActionPopup = async (config: PopupConfig): Promise<PopupResult> => {
    _isOpen.value = true;
    const res = await popupDisplayActionsListener(config);
    _isOpen.value = false;
    return res;
  };

  const setRootListener = (
    listener: PopupDisplayListener,
    actionListener: PopupDisplayActionsListener
  ) => {
    if (hasRootListener) {
      return;
    }
    popupDisplayListener = listener;
    popupDisplayActionsListener = actionListener;
    hasRootListener = true;
  };

  const close = () => {
    if (_isOpen.value) {
      _isOpen.value = false;
      return true;
    }
    return false;
  };
  return {
    isOpen,
    close,
    setRootListener,
    showDisplayPopup,
    showActionPopup,
  };
})();
